<template>
    <navigation />

    <promo-header />

    <section class="section section-blue">

        <div class="container">

            <div class="row">

                <div class="col-lg-8">

                    <h2 class="mb-4">
                        Ruth
                    </h2>

                    <h5>Series Aims</h5>
                    <ul>
                        <li>
                            To understand that God is in control of every aspect of our lives and that we can trust him to care for us even in difficult situations.
                        </li>
                        <li>
                            To understand that God uses ordinary people and difficult circumstances to bring about his bigger plan for the world.
                        </li>
                    </ul>

                    <h5 class="mt-4">Series Overview</h5>
                    <p>
                        This series covers the story of Ruth the Moabitess, from her conversion to her redemption. God's sovereign care is clear throughout the book in two different ways:
                    </p>
                    <p>
                        Immediate Provision – although Naomi and Ruth had suffered greatly God was working through their pain and loss to bring Ruth to a saving faith (week 1); to bring Naomi back to Israel (week 1); and to bless and redeem them from their poverty (weeks 1 and 2).
                    </p>
                    <p>
                        Lasting Provision – God's care extended far beyond the physical or even spiritual needs of these two women. Their suffering led to Ruth's conversion in keeping with God's original promise to Abraham – that all nations would be blessed through his offspring (week 1). But their redemption led to the fulfilment of an even greater promise – that God would send a rescuer from the line of David to redeem his people once and for all (week 2).
                    </p>

                    <h5 class="mt-4">Series Outline</h5>
                    <p>
                        Lesson 1 - Bitter Ruin (Ruth 1:1-2:23)
                    </p>
                    <p>
                        Lesson 2 - Sweet Redemption (Ruth 3:1-4:22)
                    </p>

                </div>

                <div class="offset-lg-1 col">

                    <promo-sidebar />

                </div>

            </div>

        </div>

    </section>

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";
import PromoSidebar from "../partials/PromoSidebar.vue";

export default {
    name: "Ruth",

    components: {
        PromoSidebar,
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - Ruth`,
            meta: [
                {
                    name: 'description',
                    content: "To understand that God is in control of every aspect of our lives and that we can trust him to care for us even in difficult situations.",
                },
            ],
        };
    },
};
</script>
